module.exports = __webpack_public_path__ + "img/p_sz_25.5afc0752.png";